

import React, { useState, useContext, useEffect } from 'react';

import PageContentWrapper from '../components/pageContentWrapper';
import { TestMessagingForm } from './TestMessagingForm';
import { sendMessageConfigurationTestEmail } from '../../service/messageConfigurationTestEmailService';
import { PageContext } from '../components/page';
import { getMessageConfigurations } from '../../service/messageConfigurationService';
import { type MessageConfigurationResponse } from '../../types/messageConfiguration';
import { getProperty } from '../../fsConfig';

const errors = {
  getMessageConfiguration: {
    backendFailure:
      'Failed to load message configuration. Please contact support or try again later.',
  },
  sendMessageConfigurationTestEmail: {
    backendFailure:
      'Failed to send message configuration test email. Please contact support or try again later.',
  },
};

const TestMessagingContainer: React.FC = () => {
  const { pushAlert } = useContext(PageContext);
  const user = getProperty('session', {});
  const [loading, setLoading] = useState(false);
  const [sendErrorMessage, setSendErrorMessage] = useState<string>();
  const [tripGroupsErrorMessage, setTripGroupsErrorMessage] = useState<string>();
  const [sentTestMessage, setSentTestMessage] = useState(false);
  const [messageConfigs, setMessageConfigs] = useState<MessageConfigurationResponse>();

  const getConfigs = async () => {
    setLoading(true);
    try {
      const response = await getMessageConfigurations();
      setMessageConfigs(response);
      setTripGroupsErrorMessage('');
    } catch (_error) {
      setMessageConfigs([]);
      setTripGroupsErrorMessage(errors.getMessageConfiguration.backendFailure);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConfigs();
  }, []);

  useEffect(() => {
    user?.accountId === '345' && pushAlert('conducive');
  }, []);

  const handleSendTestEmailMessage = async (
    messageConfigId: string,
    testMessageType: string,
    email: string,
  ): Promise<void> => {
    setLoading(true);
    setSentTestMessage(false);

    try {
      await sendMessageConfigurationTestEmail(messageConfigId, testMessageType, email);
      setSentTestMessage(true);
    } catch (_error) {
      setSendErrorMessage(errors.sendMessageConfigurationTestEmail.backendFailure);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContentWrapper loading={loading} title="TEST MESSAGING">
      <TestMessagingForm
        onSendTestEmailMessage={handleSendTestEmailMessage}
        sendErrorMessage={sendErrorMessage}
        getTripGroupsErrorMessage={tripGroupsErrorMessage}
        sentTestMessage={sentTestMessage}
        messageConfigs={messageConfigs || []}
      />
    </PageContentWrapper>
  );
};

export default TestMessagingContainer;
